export default __webpack_public_path__ + "static/media/Corpus Belt.38055d3c.jpg";